import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faArrowRight } from '@fortawesome/free-solid-svg-icons';
import { Particles } from '../ui/particles';
import { GradientText } from '../ui/gradient-text';
import { MagneticButton } from '../ui/magnetic-button';
import { FlipWords } from '../ui/flip-words';
import { StackCarousel } from '../ui/stack-carousel';
import { trackButtonClick } from '../../utils/analytics';
import { useNavigate, useParams } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

const Hero: React.FC = () => {
  // @ts-ignore - react-i18next supports namespace parameter but TypeScript types don't reflect it
  const { t } = useTranslation('landing');
  const words = t('hero.flipWords', { returnObjects: true }) as string[];

  const navigate = useNavigate();
  const { lang } = useParams<{ lang: string }>();

  const handleGetStarted = () => {
    trackButtonClick('get_started', 'hero_section');
    // Scroll to the form section
    return navigate(`/${lang}/register`);
  };

  return (
    <div
      className="relative z-10 max-w-7xl mx-auto text-center py-4 sm:py-16 md:py-20 flex flex-col justify-center"
      style={{
        paddingTop: '4rem',
        paddingLeft: 'clamp(0.5rem, 2vw + 0.25rem, 2rem)',
        paddingRight: 'clamp(0.5rem, 2vw + 0.25rem, 2rem)'
      }}
    >
      {/* Platform Logos */}
      <div className="h-full">
        {/* Badge */}
        {/* <div 
          className="inline-flex items-center space-x-2 bg-purple-600/20 border border-purple-400/30 rounded-full px-10 py-2 mb-6"
          // style={{
          //   paddingLeft: 'clamp(1rem, 3vw + 0.5rem, 2.5rem)',
          //   paddingRight: 'clamp(1rem, 3vw + 0.5rem, 2.5rem)',
          //   paddingTop: 'clamp(0.5rem, 1vw + 0.25rem, 0.75rem)',
          //   paddingBottom: 'clamp(0.5rem, 1vw + 0.25rem, 0.75rem)'
          // }}
        >
          <div className="flex flex-col">
            <span 
              className="text-purple-300 font-medium"
              style={{
                fontSize: 'clamp(0.75rem, 2vw + 0.25rem, 0.875rem)'
              }}
            >
              AI Destekli sosyal medya Varlık
            </span>
            <FlipWords
              words={words}
              duration={1500}
              className="text-blue-500 font-semibold"
            />
          </div>
        </div> */}

        {/* Main Headline */}
        <div className="mb-10 sm:mb-12 relative">
          <div className="flex flex-wrap items-center justify-center gap-3 sm:gap-4 md:gap-6 relative">
            <div
              className="flex items-center justify-center backdrop-blur-sm rounded-lg sm:rounded-xl p-3 sm:p-4 md:p-5 transition-all duration-300 relative overflow-hidden"
              style={{
                border: '1px solid rgba(255, 255, 255, 0.07)'
              }}
            >
              <div
                className="absolute inset-0 rounded-lg sm:rounded-xl pointer-events-none"
                style={{
                  backgroundColor: 'rgba(255, 255, 255, 0.035)',
                  maskImage: 'linear-gradient(to bottom, transparent 0%, rgba(0,0,0,0.3) 40%, black 100%)',
                  WebkitMaskImage: 'linear-gradient(to bottom, transparent 0%, rgba(0,0,0,0.3) 40%, black 100%)',
                }}
              ></div>
              <img
                src="/platforms/google.png"
                alt="Google API"
                className="h-6 sm:h-8 md:h-10 w-auto object-contain relative z-10 opacity-100"
                style={{
                  maxHeight: 'clamp(1.25rem, 3vw + 0.5rem, 2.5rem)'
                }}
              />
            </div>
            <div
              className="flex items-center justify-center backdrop-blur-sm rounded-lg sm:rounded-xl p-3 sm:p-4 md:p-5 transition-all duration-300 relative overflow-hidden"
              style={{
                border: '1px solid rgba(255, 255, 255, 0.07)'
              }}
            >
              <div
                className="absolute inset-0 rounded-lg sm:rounded-xl pointer-events-none"
                style={{
                  backgroundColor: 'rgba(255, 255, 255, 0.035)',
                  maskImage: 'linear-gradient(to bottom, transparent 0%, rgba(0,0,0,0.3) 40%, black 100%)',
                  WebkitMaskImage: 'linear-gradient(to bottom, transparent 0%, rgba(0,0,0,0.3) 40%, black 100%)',
                }}
              ></div>
              <img
                src="/platforms/linkedin.png"
                alt="LinkedIn API"
                className="h-6 sm:h-8 md:h-10 w-auto object-contain relative z-10 opacity-100"
                style={{
                  maxHeight: 'clamp(1.25rem, 3vw + 0.5rem, 2.5rem)'
                }}
              />
            </div>
            <div
              className="flex items-center justify-center backdrop-blur-sm rounded-lg sm:rounded-xl p-3 sm:p-4 md:p-5 transition-all duration-300 relative overflow-hidden"
              style={{
                border: '1px solid rgba(255, 255, 255, 0.07)'
              }}
            >
              <div
                className="absolute inset-0 rounded-lg sm:rounded-xl pointer-events-none"
                style={{
                  backgroundColor: 'rgba(255, 255, 255, 0.035)',
                  maskImage: 'linear-gradient(to bottom, transparent 0%, rgba(0,0,0,0.3) 40%, black 100%)',
                  WebkitMaskImage: 'linear-gradient(to bottom, transparent 0%, rgba(0,0,0,0.3) 40%, black 100%)',
                }}
              ></div>
              <img
                src="/platforms/meta.png"
                alt="Meta API"
                className="h-6 sm:h-8 md:h-10 w-auto object-contain relative z-10 opacity-100"
                style={{
                  maxHeight: 'clamp(1.25rem, 3vw + 0.5rem, 2.5rem)'
                }}
              />
            </div>
            <div
              className="flex items-center justify-center backdrop-blur-sm rounded-lg sm:rounded-xl p-3 sm:p-4 md:p-5 transition-all duration-300 relative overflow-hidden"
              style={{
                border: '1px solid rgba(255, 255, 255, 0.07)'
              }}
            >
              <div
                className="absolute inset-0 rounded-lg sm:rounded-xl pointer-events-none"
                style={{
                  backgroundColor: 'rgba(255, 255, 255, 0.035)',
                  maskImage: 'linear-gradient(to bottom, transparent 0%, rgba(0,0,0,0.3) 40%, black 100%)',
                  WebkitMaskImage: 'linear-gradient(to bottom, transparent 0%, rgba(0,0,0,0.3) 40%, black 100%)',
                }}
              ></div>
              <img
                src="/platforms/tiktok.png"
                alt="TikTok API"
                className="h-6 sm:h-8 md:h-10 w-auto object-contain relative z-10 opacity-100"
                style={{
                  maxHeight: 'clamp(1.25rem, 3vw + 0.5rem, 2.5rem)'
                }}
              />
            </div>
            <div
              className="flex items-center justify-center backdrop-blur-sm rounded-lg sm:rounded-xl p-3 sm:p-4 md:p-5 transition-all duration-300 relative overflow-hidden"
              style={{
                border: '1px solid rgba(255, 255, 255, 0.07)'
              }}
            >
              <div
                className="absolute inset-0 rounded-lg sm:rounded-xl pointer-events-none"
                style={{
                  backgroundColor: 'rgba(255, 255, 255, 0.035)',
                  maskImage: 'linear-gradient(to bottom, transparent 0%, rgba(0,0,0,0.3) 40%, black 100%)',
                  WebkitMaskImage: 'linear-gradient(to bottom, transparent 0%, rgba(0,0,0,0.3) 40%, black 100%)',
                }}
              ></div>
              <img
                src="/platforms/twitter-x.png"
                alt="Twitter X API"
                className="h-6 sm:h-8 md:h-10 w-auto object-contain relative z-10 opacity-100"
                style={{
                  maxHeight: 'clamp(1.25rem, 3vw + 0.5rem, 2.5rem)'
                }}
              />
            </div>
          </div>
        </div>
        <h1
          className="font-bold text-white mb-4 sm:mb-6 leading-tight my-6 sm:my-8 md:my-10 px-4"
          style={{
            fontSize: 'clamp(1.875rem, 8vw + 1rem, 4.5rem)',
            lineHeight: 'clamp(2.25rem, 9vw + 1.25rem, 5rem)'
          }}
        >
          {t('hero.title')}
          <GradientText
            className="block font-bold"
            text={t('hero.titleHighlight')}
            style={{
              fontSize: 'clamp(1.5rem, 6vw + 0.5rem, 5rem)',
              lineHeight: 'clamp(1.75rem, 7vw + 0.75rem, 3.5rem)'
            }}
          />
          {t('hero.titleEnd') && <span className="block">{t('hero.titleEnd')}</span>}
        </h1>

        {/* Subtitle */}
        <p
          className="text-white/70 mb-6 sm:mb-8 max-w-3xl mx-auto leading-relaxed my-6 sm:my-8 md:my-10 px-4"
          style={{
            fontSize: 'clamp(0.875rem, 2.5vw + 0.5rem, 1.5rem)',
            lineHeight: 'clamp(1.25rem, 3vw + 0.75rem, 2rem)',
            // orphans: 4,
            // widows: 4,
            // textWrap: 'pretty'
          }}
        >
          {t('hero.subtitle')}
        </p>

        {/* CTA Buttons */}
        <div className="flex flex-col sm:flex-row items-center justify-center space-y-4 sm:space-y-0 sm:space-x-6 pt-8 mt-6 sm:mt-8 md:mt-10 px-4">
          <button
            onClick={handleGetStarted}
            className="w-auto bg-gradient-to-r from-purple-500 to-purple-700 px-20 sm:px-20 md:px-20 py-3 sm:py-4 rounded-xl text-white font-semibold text-sm sm:text-base md:hover:from-purple-600 md:hover:to-purple-800 transition-all duration-300 transform md:hover:scale-105 md:active:scale-95 touch-manipulation"
            style={{
              WebkitTapHighlightColor: 'transparent',
              WebkitTouchCallout: 'none',
              WebkitUserSelect: 'none',
              userSelect: 'none'
            }}
          >
            <span className="flex items-center justify-center space-x-2" onClick={handleGetStarted}>
              <span>{t('hero.getStarted')}</span>
            </span>
          </button>
        </div>
      </div>

      {/* Module Screenshots - Stack Carousel */}

      <Particles
        className="absolute inset-0 hidden md:block"
        quantity={300}
        ease={80}
        color="#ffffff"
        refresh
      />
    </div>
  );
};

export default Hero;
